<mat-dialog-content [formGroup]="demande">

    <mat-intro-helper *ngIf="!isFramed && introState | async" (onClick)="introReplay()" class="mat-accent" 
        style="position: absolute; top: 0; right: 0; z-index: 1"></mat-intro-helper>

	<mat-stepper linear formArrayName="steps" showError orientation="vertical" style="margin: 0 -24px" #demandeStepper>
		<ng-template matStepperIcon="edit">
			<mat-icon>done</mat-icon>
		</ng-template>
		<mat-step formGroupName="0" [stepControl]="demande.controls.steps?.get([0])" [completed]="demande.controls.steps?.get([0]).valid">
			<ng-template matStepLabel>Indiquez sur quelle plateforme est votre demande</ng-template>
			<mat-list style="padding: 0">
				<div mat-subheader class="mat-red">Ce choix est important pour la bonne prise en compte de votre demande et la rapidité d'exécution.</div>
				<mat-list-item id="demandes-new-types">
					<mat-button-toggle-group formControlName="type_id" name="type_id" (change)="validateAndNext()" 
						fxLayout="row wrap" fxLayout.xs="column">
						<mat-button-toggle *ngFor="let type of types | async" [value]="type.id" class="mat-primary" fxFlex="1 0 250px" 
                            (click)="setActors(type.actors)">
							<div class="mat-button-toggle-header">
								<mat-icon>{{type.icon}}</mat-icon> {{type.label}}
							</div>
							<p style="white-space: pre-wrap; text-align: left;">{{type.description}}</p>
						</mat-button-toggle>
					</mat-button-toggle-group>
				</mat-list-item>
			</mat-list>
		</mat-step>
		<mat-step formGroupName="1" [stepControl]="demande.controls.steps?.get([1])">
			<ng-template matStepLabel>Indiquez la nature de votre demande</ng-template>
			<mat-list style="padding: 0">
				<div mat-subheader>Quelle est la nature de votre demande, sélectionnez parmi les 3 choix suivants.</div>
				<mat-list-item id="demandes-new-reasons">
					<mat-button-toggle-group formControlName="reason_id" name="reason_id" (change)="resetImportances(); validateAndNext()" fxLayout.xs="column">
						<mat-button-toggle *ngFor="let reason of reasons | async" [value]="reason.id" class="mat-{{reason.color}}">
							<div class="mat-button-toggle-header">
								<mat-icon>{{reason.icon}}</mat-icon> {{reason.label}}
							</div>
							<p style="white-space: pre-wrap; text-align: left;">{{reason.description}}</p>
						</mat-button-toggle>
					</mat-button-toggle-group>
				</mat-list-item>

				<div mat-subheader>Quelle est l'urgence de votre demande, sélectionnez parmi les 
					{{ demande.controls.steps?.get([1, 'reason_id']).value === 2 ? '2' : '3' }}
					choix suivants.
				</div>
				<mat-list-item id="demandes-new-importances">
					<mat-button-toggle-group formControlName="importance_id" name="importance_id" (change)="validateAndNext()" fxLayout.xs="column">
						<mat-button-toggle *ngFor="let importance of importances | async" [value]="importance.id" [disabled]="!importance.canActivate()"
							class="mat-{{importance.color}}" fxFlex>
							<div class="mat-button-toggle-header">
								<mat-icon>{{importance.icon}}</mat-icon> {{importance.label}}
							</div>
							<p style="white-space: pre-wrap; text-align: left;">{{importance.description}}</p>
						</mat-button-toggle>
					</mat-button-toggle-group>
				</mat-list-item>
			</mat-list>
		</mat-step>
		<mat-step formGroupName="2" [stepControl]="demande.controls.steps?.get([2])">
			<ng-template matStepLabel>Finalisation de la demande</ng-template>
			<mat-form-field fxFlex="1 1 auto" id="demandes-new-actors">
				<mat-label>Acteurs de la demande</mat-label>
				<mat-user-autocomplete disableWithoutGUID formControlName="actors" placeholder="Rechercher..."></mat-user-autocomplete>
				<mat-hint>Il n'est pas necessaire d'ajouter l'auteur de la demande dans cette liste</mat-hint>
			</mat-form-field>
			<mat-form-field style="margin-top: 1em;" id="demandes-new-subject">
				<mat-label>Sujet de la demande</mat-label>
				<input matInput formControlName="subject">
			</mat-form-field>
			<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" style="margin-top: 1em;">
				<mat-form-field [matFileInputTriggerFor]="fileInputElement" class="mat-form-field-without-hint" id="demandes-new-description">
					<mat-label>Description de votre demande</mat-label>
					<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="5" formControlName="description" (paste)="onPaste($event)"></textarea>
				</mat-form-field>
				<mat-file-input #fileInputElement formControlName="attached" multiple accept=".pdf,.xls*,.doc*,.ppt*,.txt,.csv,.msg,image/*" 
					placeholder="Pour ajouter des pièces jointes, glissez des fichiers dans cette zone ou collez les, vous pouvez aussi cliquer ici"
					fxFlex.gt-xs="0 0 33%" id="demandes-new-attached"></mat-file-input>
			</div>
		</mat-step>
	</mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close *ngIf="dialogRef">Annuler</button>
	<button mat-flat-button class="mat-green" [disabled]="!demande.valid" (click)="add()" id="demandes-new-send">
		<mat-icon>check</mat-icon>
		Envoyer ma demande
	</button>
</mat-dialog-actions>